import { render, staticRenderFns } from "./BankReportsTable.vue?vue&type=template&id=724562d2&"
import script from "./BankReportsTable.vue?vue&type=script&lang=js&"
export * from "./BankReportsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports